import {
  RoomId,
  roomId,
  RoomStageLayout,
  roomStageLayout
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomStageLayoutUpdateRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomStageLayoutUpdateRequestDTO.validationSchema()
  );

  constructor(readonly data: RoomStageLayoutUpdateRequest) {
    JsonSchemaValidator.assert(
      RoomStageLayoutUpdateRequestDTO.validation,
      data
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "layout"],
      properties: {
        roomId,
        layout: roomStageLayout
      }
    };
  }
}

interface RoomStageLayoutUpdateRequest {
  roomId: RoomId;
  layout: RoomStageLayout;
}
